var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(0.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_100",
    "data-name": "Ellipse 100",
    transform: "translate(-0.442)",
    fill: "#f8991c",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(6.558 13)",
    fill: "#fff",
    fontSize: 11,
    fontFamily: "OpenSans-Bold, OpenSans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICA8ZyBpZD0iR3JvdXBfNjA4IiBkYXRhLW5hbWU9Ikdyb3VwIDYwOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC40NDIpIj4KICAgIDxnIGlkPSJFbGxpcHNlXzEwMCIgZGF0YS1uYW1lPSJFbGxpcHNlIDEwMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTAuNDQyKSIgZmlsbD0iI2Y4OTkxYyIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjguNSIgc3Ryb2tlPSJub25lIi8+CiAgICAgIDxjaXJjbGUgY3g9IjguNSIgY3k9IjguNSIgcj0iOCIgZmlsbD0ibm9uZSIvPgogICAgPC9nPgogICAgPHRleHQgaWQ9Il8iIGRhdGEtbmFtZT0iISIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi41NTggMTMpIiBmaWxsPSIjZmZmIiBmb250LXNpemU9IjExIiBmb250LWZhbWlseT0iT3BlblNhbnMtQm9sZCwgT3BlblNhbnMiIGZvbnQtd2VpZ2h0PSI3MDAiPjx0c3BhbiB4PSIwIiB5PSIwIj4hPC90c3Bhbj48L3RleHQ+CiAgPC9nPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };